import React, { useState } from 'react';
import { IconButton } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { FaSyncAlt } from 'react-icons/fa';
import { useStoreState } from '../../store/hooks';
import { createPricingTriggers } from '../../api/pricing/pricing';
import { notificationSuccess } from '../../services/notificationActions';
import handleError from '../../api/apiErrorHandle';
import Alert from '../Alert';

export default function PricingRecalculate() {
  const currentFilter = useStoreState(state => state.pricingData.currentFilter);
  const totalItems = useStoreState(state => state.pricingData.total);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [recalculating, setRecalculating] = useState(false);

  async function handleRecalculate() {
    setRecalculating(true);
    try {
      const response = await createPricingTriggers(currentFilter.filter);
      notificationSuccess(`Submitted ${response.data.submittedCount} pricing triggers.`);
    } catch (error) {
      handleError(error);
    } finally {
      setRecalculating(false);
      setConfirmOpen(false);
    }
  }

  return (
    <>
      <IconButton
        style={{ width: 220 }}
        appearance="primary"
        icon={<Icon as={FaSyncAlt} />}
        placement="right"
        onClick={() => setConfirmOpen(true)}
      >
        Recalculate in price service
      </IconButton>

      <Alert
        isOpen={confirmOpen}
        isLoading={recalculating}
        onConfirm={() => handleRecalculate()}
        onClose={() => setConfirmOpen(false)}
        title="Confirmation"
      >
        <p>
          Are you sure you want to recalculate
          {' '}
          <b>{totalItems}</b>
          {' '}
          items?
        </p>
      </Alert>
    </>
  );
}
